import * as React from 'react';
import { Col } from 'antd';
import { SelectOption } from 'client/ui/form/input/SelectInput';
import { SelectInputItem } from 'client/ui/form/input/SelectInputItem';
import { useTranslation } from 'react-i18next';
import {
  useClientConfig,
  useModuleConfigEnum
} from '../../config/ClientConfigModule';

export interface ProcedureAdministrationCodesFilterProps {}

/**
 * Select per la scelta dell'Amministrazione
 */
export function ProcedureAdministrationCodesFilter(
  props: ProcedureAdministrationCodesFilterProps
) {
  const features = useClientConfig()?.documental.features;
  const administrationCodes = useModuleConfigEnum(
    features?.configFeatureName ?? 'none',
    'administrationCodes'
  );
  const { t } = useTranslation();

  // Se non è supportata la modalità multi-amministrazione, non mostrare il componente
  if (!features?.hasMultipleAdministration || !administrationCodes) {
    return null;
  }

  return (
    <Col span={24} md={4}>
      <SelectInputItem
        name="administrationCode"
        label={t('procedures.aoo-filter-select.label', 'Amministrazione')}
        placeholder={t(
          'procedures.aoo-filter-select.placeholder',
          'Codice Amministrazione..'
        )}
        dropdownMatchSelectWidth={400}
        showSearch
        optionFilterProp="label"
        allowClear
        options={
          administrationCodes.members.map(item => ({
            label: `${item.key} - ${item.text}`,
            value: item.key
          })) as SelectOption[]
        }
      />
    </Col>
  );
}
